<template>
  <!--
      作者：gmshop
      时间：2019-10-25
      描述：会员-用户列表-会员等级
  -->
  <div>
  <el-dialog title="会员等级" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small" :model="form">
      <el-form-item label="昵称" :label-width="formLabelWidth">
        <el-input v-model="form.nickName" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="上级邀请人ID" :label-width="formLabelWidth">
          <el-input type="text" v-model="form.referee_id" autocomplete="off">
          <el-button slot="append" type="primary" icon="el-icon-user-solid" @click="openUserDialog">选择上级用户</el-button>
          </el-input>
        </el-form-item>
      <el-form-item label="上级归属人ID" :label-width="formLabelWidth">
          <el-input type="number" min="0" v-model="form.belong_id" autocomplete="off">
          </el-input>
        </el-form-item>
      <el-form-item label="等级" :label-width="formLabelWidth">
        <el-select v-model="form.grade_id" placeholder="-请选择等级-">
          <el-option v-for="(item,index) in gradeList" :key="index" :label="item.name" :value="item.grade_id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="电话" :label-width="formLabelWidth">
        <el-input v-model="form.mobile" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="密码修改" :label-width="formLabelWidth">
        <el-input v-model="form.password1" autocomplete="off"></el-input>
        <div class="lh18 mt10 gray9">
          <p>注：如不修改则保留空</p>
        </div>
      </el-form-item>
      <el-form-item label="黑名单"  :label-width="formLabelWidth">
        <div>
          <el-radio v-model="form.is_black" :label="0">否</el-radio>
          <el-radio v-model="form.is_black" :label="1">是</el-radio>
          <div class="tips">如果设置为黑名单，将不能访问系统</div>
        </div>
      </el-form-item>
      <el-form-item label="管理员备注" :label-width="formLabelWidth">
        <el-input type="textarea" v-model="form.remark" placeholder="请输入管理员备注"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="editUser" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
   <!--用户选择-->
  <GetUser :is_open="open_user" @close="closeUserDialog"></GetUser>
  </div>
</template>

<script>
  import UserApi from '@/api/user.js';
  import GetUser from '@/components/user/GetUser.vue';
  export default {
    components: {
      GetUser
    },
    data() {
      return {
         open_user: false,
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        loading: false,
        dialogVisible: false,
      };
    },
    props: ['open_edit', 'form', 'gradeList'],
    created() {

      this.dialogVisible = this.open_edit;

    },
    methods: {

      /*修改用户*/
      editUser() {
        let self = this;
        self.loading = true;
        let params = self.form;
        UserApi.edituser(params, true)
          .then(data => {
            self.loading = false;
            if (data.code == 1) {
              self.$message({
                message: '恭喜你，用户修改成功',
                type: 'success'
              });
              self.dialogFormVisible(true);
            }
          })
          .catch(error => {
            self.loading = false;
          });
      },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },
      /*打开用户弹窗*/
    openUserDialog() {
      this.open_user = true;
    },
    /*关闭用户弹窗*/
    closeUserDialog(e) {
      if (e.type != 'error') {
        this.user = e.params[0];
        this.form.referee_id = e.params[0].user_id;
      }
      this.open_user = false;
    },


    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/user/user/dialog/Grade.vue